// PULSORA WEB PUSH V1
import React, { useCallback, useEffect, useState } from 'react';
import { BellRing, CheckCircle2, TriangleAlert } from 'lucide-react';
import { enableWebPush, getWebPushStatus } from '../../platform/pushMessaging';

export default function WebPushControl() {
  const [state, setState] = useState({ supported: false, permission: 'loading' });
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  const refresh = useCallback(async () => {
    try {
      setState(await getWebPushStatus());
    } catch (_) {
      setState({ supported: false, permission: 'unsupported' });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  if (!state.supported) return null;

  if (state.permission === 'granted') {
    return <div className="web-push-control active"><CheckCircle2 size={16}/><span><b>Notificaciones del navegador activas</b><small>Este dispositivo puede recibir avisos de Pulsora.</small></span></div>;
  }

  if (state.permission === 'denied') {
    return <div className="web-push-control blocked"><TriangleAlert size={16}/><span><b>Notificaciones bloqueadas</b><small>Habilitalas desde los permisos del sitio en tu navegador.</small></span></div>;
  }

  const activate = async () => {
    if (busy) return;
    setBusy(true);
    setMessage('');
    try {
      await enableWebPush();
      await refresh();
    } catch (error) {
      setMessage(error?.message || 'No fue posible activar las notificaciones.');
      await refresh();
    } finally {
      setBusy(false);
    }
  };

  return <div className="web-push-control prompt"><BellRing size={16}/><span><b>Recibe avisos en este dispositivo</b><small>Activalos para clases, pagos, comunidad y otros eventos de Pulsora.</small>{message && <em>{message}</em>}</span><button type="button" onClick={activate} disabled={busy}>{busy ? 'Activando...' : 'Activar'}</button></div>;
}
